module.exports = __webpack_public_path__ + "static/media/Luis_Martin_Chavarria_Cortes.7aff87c0.jpg";